// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  width: 350px;
}
:host .container .item-block {
  display: block;
}
:host .container .item-block mat-select,
:host .container .item-block input,
:host .container .item-block span {
  width: calc(100% - 5px);
}
:host .container .item-param {
  display: block;
}
:host .container .item-param input {
  width: 150px;
}`, "",{"version":3,"sources":["webpack://./src/app/device/tag-options/tag-options.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/device/tag-options/tag-options.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;ACAR;ADEQ;EACI,cAAA;ACAZ;ADEY;;;EAGI,uBAAA;ACAhB;ADIQ;EACI,cAAA;ACFZ;ADIY;EACI,YAAA;ACFhB","sourcesContent":[":host {\n    .container {\n        width: 350px;\n\n        .item-block {\n            display: block;\n\n            mat-select,\n            input,\n            span {\n                width: calc(100% - 5px);\n            }\n        }\n\n        .item-param {\n            display: block;\n\n            input {\n                width: 150px;\n            }\n        }\n    }\n}",":host .container {\n  width: 350px;\n}\n:host .container .item-block {\n  display: block;\n}\n:host .container .item-block mat-select,\n:host .container .item-block input,\n:host .container .item-block span {\n  width: calc(100% - 5px);\n}\n:host .container .item-param {\n  display: block;\n}\n:host .container .item-param input {\n  width: 150px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
